export default "__VITE_ASSET__C0CxEhde__"